<ng-container *ngIf="form.get(fieldName) || fieldControl as f; else errore">
  <label *ngIf="fieldLabel" [for]="fieldName" class="form-label">{{ fieldLabel }}</label>
  <ng-container *ngIf="isNumeric; else textSection">
    <custom-numeric-string-input
      [class.is-invalid]="f.errors"
      [class.is-warned]="!!warnings"
      [maxFractionDigits]="maxFractionDigits"
      [maxIntegerDigits]="maxIntegerDigits"
      [formControl]="f | toFormControl"
      [disabled]="readonlyField"
      [id]="fieldName"
      [placeholder]="!!placeholder ? placeholder : null"
    ></custom-numeric-string-input>
  </ng-container>
  <ng-template #textSection>
    <input
      *ngIf="!readonlyField; else readonlyInput"
      type="text"
      class="form-control"
      [ngClass]="{
                'no-input-style': noInputStyle,
                'text-end': textEnd
            }"
      [class.is-invalid]="f.errors"
      [class.is-warned]="!!warnings"
      [attr.maxlength]="maxStringLength || null"
      [placeholder]="!!placeholder ? placeholder : null"
      [formControl]="f | toFormControl"
      [id]="fieldName"
    />

    <ng-template #readonlyInput>
      <input
        type="text"
        disabled
        class="form-control"
        [ngClass]="{
                    'no-input-style': noInputStyle,
                    'text-end': textEnd
                }"
        [class.is-invalid]="f.errors"
        [value]="f.value"
        [id]="fieldName"
        [attr.placeholder]="readonlyField ? '' : placeholder"
      />
    </ng-template>
  </ng-template>

  <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>

  <field-warnings [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>
</ng-container>

<ng-template #errore>
  Il campo <i>{{ fieldName }}</i> non esiste
</ng-template>
